import {ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {ValuationTabComponent} from '../valuation-tab.component';
import {Observable, of} from 'rxjs';

@Component({
  selector: 'app-valuation-complete-tab',
  imports: [],
  templateUrl: './valuation-complete-tab.component.html',
  styles: ``,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ValuationCompleteTabComponent extends ValuationTabComponent<null> {
  protected readonly tabTitle = 'Complete';

  protected override loadData(): Observable<null> {
    return of(null);
  }
}
